import React from 'react';
import {ThumbnailImage} from '@wix/wix-ui-tpa/cssVars';
import {Document, GiftSmall, Download} from '@wix/wix-ui-icons-common/on-stage';
import {resizeMediaByWidth} from '@wix/wixstores-client-core';
import {ProductType} from '../../../../../constants';
import {Media} from '../../../../../../../types/app.types';
import s from './Thumbnail.scss';

export const ThumbnailDataHook = Object.freeze({
  Wrapper: 'typ-product-thumbnail-wrapper',
  Media: 'typ-product-thumbnail-media',
  DefaultImage: 'typ-default-image',
  Badge: 'typ-product-badge',
});

const THUMBNAIL_SIZE = 100;
const DEFAULT_ICON_SIZE = '50';

type ThumbnailProps = {
  name: string;
  media?: Media | null;
  productType: string;
};

export function Thumbnail(props: ThumbnailProps) {
  return (
    <div className={s.thumbnail}>
      <ThumbnailContent {...props} />
    </div>
  );
}

Thumbnail.displayName = 'ProductLineItem.Image';

function ThumbnailContent({name, media, productType}: ThumbnailProps) {
  const isDigital = productType === ProductType.Digital;
  const {width, height} = getImageDimensions(media);

  if (!media?.url) {
    return (
      <div data-hook={ThumbnailDataHook.DefaultImage} className={s.defaultImage} style={{width, height}}>
        {isDigital ? <Document size={DEFAULT_ICON_SIZE} /> : <GiftSmall size={DEFAULT_ICON_SIZE} />}
      </div>
    );
  }

  return (
    <div className={s.productImage} data-hook={ThumbnailDataHook.Wrapper}>
      <ThumbnailImage
        data-hook={ThumbnailDataHook.Media}
        src={media.url}
        width={width}
        height={height}
        alt={media.altText || /* istanbul ignore next */ name}
        aria-hidden={false}
      />
      {isDigital && (
        <div className={s.productBadge} data-hook={ThumbnailDataHook.Badge}>
          <Download />
        </div>
      )}
    </div>
  );
}

function getImageDimensions(media?: Media | null) {
  if (!media?.url) {
    return {width: THUMBNAIL_SIZE, height: THUMBNAIL_SIZE};
  }
  return resizeMediaByWidth(media, THUMBNAIL_SIZE);
}
